module.exports = __webpack_public_path__ + "static/media/icon_menu_dots_white.690acf66.svg";